/* ============================================================
   SANTJAKOV — tema de Shopify · "The Exhibition"
   theme.js — SOLO el comportamiento del sitio (el "chrome").

   Extraído TAL CUAL del app.js del sitio estático (18 ago 2026): mismos
   tiempos, mismas curvas, mismos valores medidos. No se reescribió nada —
   todo esto ya estaba probado en producción y varias de estas constantes
   costaron rondas de ajuste (ver LEEME-handoff.md del sitio estático).

   Lo que NO vive aquí, porque en el tema lo da Shopify: el catálogo, la
   ficha de producto, el buscador, el carrito y el checkout. El CATALOG
   escrito a mano desaparece.
   ============================================================ */
(function(){
  const D=document, root=document.documentElement, body=document.body;
  root.classList.remove('no-js');
  /* ─────────────────────────────────────────────
     SMOOTH SCROLL (Lenis)
     Misma librería y MISMA configuración que el sitio de tatuaje
     (santjakov/tattoo/web-v2), para que las dos webs de la marca se
     sientan igual al desplazarse. No se inventó una curva nueva.

     Lenis NO reemplaza el scroll: sigue moviendo el scroll real de la
     ventana, así que `scrollY`, `getBoundingClientRect`, los
     IntersectionObserver y —sobre todo— los `position:sticky` del hero,
     `.best`, `.full-col` y `.split-shot` siguen funcionando igual.
     Por eso no hay que tocar nada de la maquinaria ligada al scroll.

     Viene de un CDN externo. Si no responde, `new Lenis()` lanza y
     MATARÍA todo este archivo (catálogo, carrito, menú, cursor). El
     try/catch deja que un fallo del CDN cueste solo el smooth scroll:
     el sitio sigue con scroll nativo. Es la misma lección ya aprendida
     en el sitio de tatuaje. */
  let lenis=null;
  try{
    lenis=new Lenis({
      duration:1.2,
      easing:(t)=>Math.min(1,1.001-Math.pow(2,-10*t)),
      smoothWheel:true, wheelMultiplier:1, touchMultiplier:1.5,
    });
    const rafLoop=(time)=>{lenis.raf(time);requestAnimationFrame(rafLoop);};
    requestAnimationFrame(rafLoop);
  }catch(err){
    console.warn('[santjakov] Lenis no cargó; se usa scroll nativo.',err);
  }
  window.lenis=lenis;

  /* Las capas que scrollean POR DENTRO (la ficha de producto y los
     resultados del buscador) tienen que quedar fuera de Lenis, o la rueda
     del ratón movería la página de atrás en vez de su contenido.
     Se marcan desde aquí para no tocar el HTML de la nav. */
  D.querySelectorAll('.pview,.ns-results,.vview').forEach(el=>el.setAttribute('data-lenis-prevent',''));
  /* ─────── TOAST ─────── */
  let toastEl;
  function toast(msg){
    if(!toastEl){toastEl=D.createElement('div');toastEl.className='toast';body.appendChild(toastEl);}
    toastEl.textContent=msg;toastEl.classList.add('show');
    clearTimeout(toastEl._t);toastEl._t=setTimeout(()=>toastEl.classList.remove('show'),2600);
  }

  /* ─────────────────────────────────────────────
     CUSTOM CURSOR
     ───────────────────────────────────────────── */
  if(matchMedia('(pointer:fine)').matches){
    const dot=D.querySelector('.cursor'), ring=D.querySelector('.cursor-follow');
    if(dot&&ring){
      let mx=innerWidth/2,my=innerHeight/2,rx=mx,ry=my;
      addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;
        dot.style.transform=`translate(${mx}px,${my}px) translate(-50%,-50%)`;});
      /* 0.30, antes 0.16. Con .16 el aro tardaba unos 15 fotogramas (~250 ms) en
         alcanzar al puntero: al mover rápido y hacer clic se quedaba atrás y
         luego lo alcanzaba, y eso se lee como que el botón «rebota» o tarda en
         responder. Con .30 va pegado sin perder la suavidad del arrastre. */
      (function loop(){rx+=(mx-rx)*.30;ry+=(my-ry)*.30;
        ring.style.transform=`translate(${rx}px,${ry}px) translate(-50%,-50%)`;
        requestAnimationFrame(loop);})();
      const label=ring.querySelector('.cl');
      const hoverSel='a,button,.prod,[data-cursor]';
      D.addEventListener('mouseover',e=>{const t=e.target.closest(hoverSel);
        if(t){ring.classList.add('grow');if(label)label.textContent=t.getAttribute('data-cursor')||'';}});
      D.addEventListener('mouseout',e=>{if(e.target.closest(hoverSel))ring.classList.remove('grow');});
    }
  }

  /* ─────── Newsletter del pie ───────
     No hay backend. Reusa el mismo `toast()` que avisa al añadir al carrito,
     igual que el checkout, que también es una demo. Cuando haya servicio de
     correo, aquí es donde entra la llamada. */
  const fNews=D.getElementById('fNews');
  if(fNews){
    fNews.addEventListener('submit',ev=>{
      ev.preventDefault();
      const campo=fNews.querySelector('input');
      const valor=(campo.value||'').trim();
      /* validación mínima, la del navegador está desactivada con `novalidate`
         para que el aviso salga en el idioma y el estilo del sitio */
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(valor)){
        toast('Enter a valid email'); campo.focus(); return;
      }
      toast('Thank you — you are on the list');
      fNews.reset();
    });
  }

  /* ─────────────────────────────────────────────
     MENU OVERLAY
     ───────────────────────────────────────────── */
  const ov=D.getElementById('overlay');
  const openBtn=D.getElementById('menuOpen'), closeBtn=D.getElementById('menuClose');
  if(ov&&openBtn){
    /* `overflow:hidden` en el body ya no basta por sí solo: Lenis mueve el
       scroll por su cuenta, así que hay que pararlo y reanudarlo también. */
    const toggle=(v)=>{ov.classList.toggle('open',v);body.style.overflow=v?'hidden':'';
      if(lenis){v?lenis.stop():lenis.start();}};
    openBtn.onclick=()=>toggle(true);
    if(closeBtn)closeBtn.onclick=()=>toggle(false);
    addEventListener('keydown',e=>{if(e.key==='Escape')toggle(false);});
  }

  /* ─────────────────────────────────────────────
     PAGE TRANSITIONS  (ignore #, _blank, external, buttons)
     ───────────────────────────────────────────── */
  /* Cuánto dura el empuje de salida. Tiene que coincidir con la transición de
     `html.saliendo main` en `paginas.css`. Corto a propósito: es un empujón,
     no una cortina. */
  const SALIDA=300;

  /* Navegar con cortina. Se declara ANTES del bloque para que el buscador y
     cualquier otro sitio que navegue por JS puedan usarla; si la página no
     tiene `.ptrans`, simplemente navega. */
  let irA=href=>{location.href=href;};

  const pt=D.querySelector('.ptrans');
  if(pt){
    /* Antes la cortina se iba a los ~250 ms y nunca se alcanzaba a ver.
       Ahora, cuando entras o recargas, se queda con el logotipo hasta que la
       página está lista (con un tope de 2.2 s por si algo tarda). Al navegar
       entre páginas sigue siendo solo la transición rápida de siempre. */
    const DESDE_LINK='sjk_nav';
    const porLink=sessionStorage.getItem(DESDE_LINK);
    sessionStorage.removeItem(DESDE_LINK);

    const lockup=D.getElementById('ptLockup');
    const palabra=D.getElementById('ptWord');
    /* La entrada es una transición, no una animación con `forwards`: si fuera
       animación se quedaría fijando la opacidad al terminar y el relevo del
       final —que también va por opacidad— dejaría de funcionar. Necesita un
       fotograma con el estado inicial ya pintado antes de cambiarlo. */
    requestAnimationFrame(()=>requestAnimationFrame(()=>pt.classList.add('entrado')));

    /* Al llegar desde otro enlace NO hay cortina: el `<head>` ya dejó la página
       empujada desde abajo y aquí solo se suelta. El intro con el logotipo se
       reserva para la primera carga y las recargas — repetirlo en cada clic es
       el error 13 del checklist. */
    const soltarEmpuje=()=>{
      pt.style.display='none';
      root.classList.add('entrado');
      /* se limpia cuando la transición terminó, para no dejar clases colgando */
      setTimeout(()=>root.classList.remove('entrando','entrado'),560);
    };

    /* Volver con atrás/adelante tampoco es una entrada nueva: la página se
       muestra tal cual, sin intro. La clase la puso el <head>. */
    const deHistorial=root.classList.contains('sin-intro');
    if(porLink||deHistorial){
      requestAnimationFrame(()=>requestAnimationFrame(soltarEmpuje));
    }else{
      /* INTRO COMPLETO — misma secuencia y mismos tiempos que el sitio de
         tatuaje (web-v2):
           200 ms   la cruz entra (lo hace el CSS con su propia animación)
          1150 ms   el nombre se despliega y se abre el hueco
          2500 ms   el conjunto vuela arriba y la cortina se desvanece
          3700 ms   se funde con el logotipo de la nav y se retira la cortina */
      if(lenis)lenis.stop();
      body.style.overflow='hidden';

      /* EL RELEVO DEL LOGOTIPO (pedido de Marcelo, 19 ago 2026).
         En el sitio estático el logotipo de la nav está encendido desde el
         primer fotograma, así que durante el intro se ven los DOS a la vez: el
         del preloader viajando y el de la barra ya puesto. Se lee como que uno
         se esconde detrás del otro en vez de como un relevo.

         Mientras corre el intro se apaga el `.brand` entero —el contenedor, no
         cada imagen: así no hay que pelear con las cuatro reglas de opacidad
         que gobiernan wordmark, cruz y sus variantes crema— y se enciende
         justo en el instante en que el lockup se funde (`handoff`, a 3700 ms).
         `opacity` no afecta al layout, así que el aterrizaje medido sigue
         pudiendo medir el logotipo real de la barra. */
      root.classList.add('intro-corriendo');

      setTimeout(()=>{
        if(lockup)lockup.classList.add('with-name');
        /* El conjunto ya nace montado y del tamaño final, así que este hito
           dejó de mover nada. La clase se conserva porque el CSS del sitio de
           tatuaje la usa para el mismo preloader; aquí es inocua. */
        if(palabra)palabra.classList.add('in');
      },1150);

      /* ATERRIZAJE MEDIDO. El CSS trae un destino fijo (−23.5 px y 51 px desde
         arriba) que solo es correcto con la nav en reposo. Si la página se
         recarga con scroll —el navegador restaura la posición—, la nav ya está
         compacta: su logotipo mide 12 px en vez de 16 y su centro cae a 30 px
         del borde, así que el conjunto aterrizaba grande y por debajo del sitio.

         Aquí se mide el logotipo REAL de la nav en ese instante y se calcula el
         transform exacto. Con `translate(t) scale(k)` y origen en el centro, un
         punto que está a distancia `d` del centro (sin escalar) acaba en
         `centro + t + d·k`; de ahí salen las dos fórmulas. Si algo no se puede
         medir no se toca nada y queda el destino fijo del CSS como respaldo. */
      const aterrizarMedido=()=>{
        const logo=D.querySelector('.nav .brand .logo-mark:not(.logo-mark--alt)');
        if(!lockup||!palabra||!logo)return;
        const L=lockup.getBoundingClientRect(),
              W=palabra.getBoundingClientRect(),
              N=logo.getBoundingClientRect();
        if(!N.width||!W.width||!lockup.offsetWidth)return;
        /* escala con la que el conjunto se está viendo ahora (2 en escritorio,
           1.6 en móvil): hace falta para pasar las medidas a tamaño real */
        const esc=L.width/lockup.offsetWidth;
        if(!esc)return;
        const cx=L.left+L.width/2, cy=L.top+L.height/2;
        /* dónde cae el NOMBRE respecto al centro del conjunto, sin escalar */
        const dx=((W.left+W.width/2)-cx)/esc, dy=((W.top+W.height/2)-cy)/esc;
        /* cuánto hay que encoger para que el nombre mida lo que el de la nav */
        const k=N.width/(W.width/esc);

        /* ── POR QUÉ SE APUNTA AL CONJUNTO Y NO AL NOMBRE ──────────────────
           La cuenta de abajo alineaba el NOMBRE del sello con el de la barra.
           Funcionaba mientras el sello no cambiara de forma durante el vuelo,
           pero la cruz encoge de 38 a 24 para acabar del tamaño de la barra, y
           al encoger el nombre se corre 7 px DENTRO del conjunto — la mitad de
           los 14 que pierde la cruz, porque el conjunto se recentra solo. El
           `transform` se calcula una vez, al empezar el vuelo, así que ese
           desplazamiento posterior no lo veía nadie: el logotipo aterrizaba 7 px
           a la izquierda del de la barra y, al fundirse los dos, se leía como un
           cambio de tamaño.

           Al terminar el vuelo el sello es el MISMO conjunto que la barra —cruz
           de 24, hueco de 9, nombre de 161—, así que basta con hacer coincidir
           los dos centros y todo lo de dentro cae en su sitio, sin depender de
           cuánto encoja la cruz. Si la barra no trae conjunto (una variante sin
           cruz), se vuelve a la cuenta del nombre. */
        const conjNav=D.querySelector('.nav .brand--lockup');
        if(conjNav){
          const C=conjNav.getBoundingClientRect();
          if(C.width){
            lockup.style.transform=
              `translate(${C.left+C.width/2-cx}px,${C.top+C.height/2-cy}px) scale(${k})`;
            return;
          }
        }
        const destX=N.left+N.width/2, destY=N.top+N.height/2;
        lockup.style.transform=
          `translate(${destX-cx-dx*k}px,${destY-cy-dy*k}px) scale(${k})`;
      };

      /* En teléfono la barra no lleva logotipo (son tres iconos), así que el
         sello no tiene dónde aterrizar: se disuelve en su sitio y la cortina
         se va con él. */
      const sinVuelo=matchMedia('(max-width:900px)').matches;
      setTimeout(()=>{
        if(sinVuelo){ pt.classList.add('disuelve'); return; }
        aterrizarMedido();
        /* A QUÉ COLOR ATERRIZA. La barra no es siempre verde: sobre las
           secciones oscuras (`nav-invert`) se repinta en crema. El logotipo del
           preloader nace crema, así que solo hay que cruzarlo a verde cuando la
           barra vaya a estar en verde — que es justo cuando NO está en modo
           oscuro. Sin esta comprobación, en la portada (hero oscuro) aterrizaba
           en verde sobre una barra crema. */
        const barra=D.getElementById('nav');
        if(!barra||!barra.classList.contains('nav--dark')) pt.classList.add('a-verde');
        pt.classList.add('done');
      /* 1600, no 2500. El hito venía de cuando el nombre tardaba 1350 ms en
         desplegarse: había que esperar a que el conjunto estuviera montado.
         Ahora nace montado y el desenfoque se resuelve a los ~1100 ms, así que
         2500 dejaba al logotipo 1.4 s parado. Se le deja medio segundo de
         reposo —el gesto necesita un respiro antes de despegar— y vuela.
         El intro entero pasa de 3.9 s a 3.0 s. */
      },1600);

      setTimeout(()=>{
        pt.classList.add('handoff');
        root.classList.remove('intro-corriendo');   /* el relevo, en el mismo fotograma */
        body.style.overflow='';
        if(lenis)lenis.start();
        setTimeout(()=>{pt.style.display='none';},600);
      /* El vuelo es un `transform` de 1300 ms que arranca en el hito de 1600,
         así que no termina hasta 2900. El relevo va 100 ms después: si se
         adelanta, el logotipo se apaga mientras todavía es un pelo más grande
         y se lee como que aterriza destacado. */
      },sinVuelo?2400:3000);
    }

    /* ── LA CORTINA AL CAMBIAR DE PÁGINA ──────────────────────────────────
       Sube desde abajo hasta cubrir, se navega, y en la página siguiente sale
       hacia arriba (`subir`). Un solo barrido ascendente, sin intro. */
    irA=href=>{
      sessionStorage.setItem(DESDE_LINK,'1');
      root.classList.add('saliendo');
      /* En táctil no hay cursor que precargue la página antes del clic, así
         que esperar a que termine la salida era tiempo muerto en cada toque.
         Se navega ya: la página actual sigue en pantalla, apagándose, hasta
         que llega la siguiente. */
      setTimeout(()=>{location.href=href;},matchMedia('(hover:none),(pointer:coarse)').matches?0:SALIDA);
    };

    /* ENVIAR UN FORMULARIO TAMBIÉN ES NAVEGAR. «Add to cart» manda el
       formulario a /cart/add y Shopify devuelve el carrito: como eso no pasa
       por `irA`, la página siguiente se creía una entrada nueva y repetía la
       pantalla de carga. Se deja la misma marca que deja un enlace. */
    D.addEventListener('submit',ev=>{
      if(ev.defaultPrevented) return;
      const f=ev.target; if(!f||f.target==='_blank') return;
      let u; try{ u=new URL(f.action||location.href,location.href); }catch(e){ return; }
      if(u.origin===location.origin) sessionStorage.setItem(DESDE_LINK,'1');
    });

    /* Se comparte para que el buscador navegue con la misma transición al
       pulsar Enter, igual que cualquier enlace del sitio. */
    window.irA=irA;

    /* ── VOLVER ATRÁS CON LA FLECHA DEL NAVEGADOR ─────────────────────────
       Al navegar, `irA` deja `saliendo` puesto en el <html>, que apaga el
       `main` (opacity:0). Si el navegador guarda esa página en su bfcache, al
       pulsar «atrás» la restaura TAL CUAL —con la clase todavía puesta— y NO
       vuelve a ejecutar este script: quedaba la barra visible y el contenido
       en blanco. Pasaba a veces porque no toda página entra al bfcache.

       `pageshow` con `persisted` es el único evento que se dispara en esa
       restauración. Se limpian las clases de tránsito: `main` sin ninguna ya
       es el estado visible, así que no hay que añadir nada. */
    addEventListener('pageshow',e=>{
      if(!e.persisted)return;
      root.classList.remove('saliendo','entrando','intro-corriendo');
      pt.style.display='none';
      body.style.overflow='';
      if(lenis)lenis.start();
    });

    /* ─────── PRECARGA AL PASAR EL CURSOR ───────
       El empuje de salida dura 300 ms y luego navega, pero la página nueva
       todavía tiene que llegar: la portada pesa 240 KB, así que se notaba un
       parón entre que el contenido se apaga y aparece el destino. Con la
       transición ahora tan corta, esta precarga importa más que antes.

       Al pasar el cursor por un enlace interno se le pide al navegador que lo
       vaya trayendo. Entre que alguien apunta a un enlace y hace clic pasan
       cientos de milisegundos, así que cuando el empuje termina la página
       suele estar ya en camino.

       Se marca cada enlace para no repetir, y solo se precarga lo que este
       mismo sitio va a servir. */
    const yaPedidos=new Set();
    D.addEventListener('mouseover',ev=>{
      const a=ev.target&&ev.target.closest&&ev.target.closest('a');
      if(!a||a.target==='_blank')return;
      const href=a.getAttribute('href');
      if(!href||/^(mailto:|tel:|javascript:|#)/i.test(href))return;
      let u; try{ u=new URL(href,location.href); }catch(e){ return; }
      if(u.origin!==location.origin)return;
      if(u.pathname===location.pathname)return;
      const clave=u.pathname+u.search;
      if(yaPedidos.has(clave))return;
      yaPedidos.add(clave);
      const l=D.createElement('link');
      l.rel='prefetch'; l.href=clave; l.as='document';
      D.head.appendChild(l);
    },{passive:true});

    /* INTERCEPTA LOS ENLACES POR DELEGACIÓN, no uno por uno.
       Antes se registraba un listener sobre `a[href$=".html"]` al arrancar, y
       eso dejaba fuera los dos casos MÁS navegados del sitio:
         · los enlaces con parámetros (`category.html?cat=tees`) —los tres del
           submenú de la nav—, que no terminan en «.html»;
         · los que pinta el propio JS (las tarjetas de categoría del home y de
           «Keep exploring»), que no existían todavía cuando se registraban.
       En ambos casos se navegaba sin dejar la marca en sessionStorage, así que
       la página siguiente se creía una carga nueva y reproducía el INTRO
       ENTERO de 3.7 s. Es el error 13 del checklist.
       Va en fase de captura para llegar antes que cualquier otro handler, y
       respeta las combinaciones que abren en pestaña nueva. */
    D.addEventListener('click',ev=>{
      if(ev.button||ev.metaKey||ev.ctrlKey||ev.shiftKey||ev.altKey)return;
      const a=ev.target&&ev.target.closest&&ev.target.closest('a');
      if(!a||a.target==='_blank')return;
      const href=a.getAttribute('href');
      if(!href)return;
      /* ADAPTADO A SHOPIFY (19 ago 2026). En el sitio estático el filtro era
         `nombre.html`, porque todas las páginas eran archivos. Aquí las rutas
         son `/collections/t-shirts`, `/products/zenith-hoodie`, `/` — ninguna
         termina en «.html», así que ese filtro dejaba pasar TODOS los enlaces
         sin interceptar: cada clic recargaba sin dejar la marca en
         sessionStorage y la página siguiente reproducía el intro entero.
         Es el error 13 del checklist, reaparecido por la migración.

         Ahora se acepta cualquier enlace del MISMO origen. Se descartan los
         protocolos que no navegan (mailto:, tel:), las anclas dentro de la
         misma página —que no cambian de documento y no deben tapar nada— y
         las descargas. */
      if(/^(mailto:|tel:|javascript:)/i.test(href))return;
      if(a.hasAttribute('download'))return;
      let destino;
      try{ destino=new URL(href, location.href); }catch(e){ return; }
      if(destino.origin!==location.origin)return;
      /* ancla en la propia página: se deja al navegador */
      if(destino.pathname===location.pathname && destino.search===location.search && destino.hash) return;
      ev.preventDefault();
      irA(destino.pathname+destino.search+destino.hash);
    },true);
  }

  /* ═════════════ EL ALTO DE LA BARRA, PUBLICADO ═════════════
     La ficha de producto arranca justo debajo de la barra, así que necesita su
     alto exacto. No se puede fijar a mano: el relleno de la nav es fluido y
     cambia con el ancho, y además la barra se encoge al scrollear. Se mide y se
     escribe en el <html> como `--navH`, y se vuelve a medir al cambiar el
     tamaño de la ventana. */
  (()=>{
    const barra=D.getElementById('nav'); if(!barra) return;
    const medir=()=>D.documentElement.style.setProperty('--navH',
      Math.round(barra.getBoundingClientRect().height)+'px');
    medir();
    window.__medirNav=medir;
    addEventListener('resize',medir);
    /* La barra SE COMPACTA AL BAJAR (102 → 68). Si no se vuelve a medir, la
       ficha de producto arrancaría donde estaba la barra alta y quedaría un
       hueco de 34 px por el que se veía la página de atrás.
       Se mide en el scroll —agrupado en un cuadro para no medir de más— y
       también con un observador, por si el alto cambia sin haber scroll. */
    let pedido=false;
    const remedir=()=>{if(pedido)return;pedido=true;
      requestAnimationFrame(()=>{pedido=false;medir();});};
    addEventListener('scroll',remedir,{passive:true});
    if('ResizeObserver' in window) new ResizeObserver(remedir).observe(barra);
  })();

  /* ─────── REVEAL ON SCROLL ─────── */
  const io=new IntersectionObserver((es)=>{es.forEach(e=>{if(e.isIntersecting){
    e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});

  /* UN CONTENEDOR VACÍO NO SE OBSERVA.
     Los que llena el JS (`shopGrid`, `homePieces`, `homeCats`, `fullCollection`)
     nacen sin nada y miden 0 de alto, y un rectángulo sin área cuenta como
     visible: el observador les ponía `.in` de inmediato. Las tarjetas entraban
     entonces al contenedor YA visible —sin animación—, y al llamar después a
     `reobservar` se les quitaba la clase y se volvía a poner: se veían,
     desaparecían y reaparecían. Ese era el parpadeo del hero de categoría.
     Vacío se queda fuera; entra a la cola cuando ya tiene contenido. */
  const vacio=el=>!el.firstElementChild&&!el.textContent.trim();
  const observeReveals=()=>D.querySelectorAll('.reveal:not(.in)')
    .forEach(el=>{if(!vacio(el))io.observe(el);});

  /* Devuelve a la cola un contenedor que el JS acaba de llenar. Hay que
     llamarlo SIEMPRE que se pinte dentro de un `.reveal`, o la sección se
     queda sin aparecer. */
  const reobservar=el=>{if(el){el.classList.remove('in');io.observe(el);}};
  observeReveals();
  /* Red de seguridad: los bloques que pintan van más abajo en este archivo, así
     que en el siguiente tick ya tienen contenido. Recoge cualquier contenedor
     que se haya llenado sin llamar a `reobservar`. */
  setTimeout(observeReveals,0);

  /* ═════════════ EL PIE ═════════════
     No hay nada que hacer aquí: el pie es una sección más, del color de la
     página, y se llega a él scrolleando. Se eliminó el IntersectionObserver
     que le ponía `is-green` y el listener de scroll que disolvía la sección
     de arriba (`--g` sobre .home-look / .full-col / .otras). Si vuelve a
     pedirse una animación de llegada, ver el LEEME-handoff (v18–v19). */

  /* ═════════════ MANIFIESTO · el texto se pone verde con el scroll ═════════════
     Cada palabra arranca en gris casi invisible y va tomando el verde Rainforest
     conforme la sección atraviesa la pantalla. El avance está ligado al scroll,
     no a un temporizador: si te detienes, el texto se detiene contigo. */
  const mfBlock=D.querySelector('.mf-block');
  if(mfBlock){
    mfBlock.querySelectorAll('.w-split').forEach(el=>{
      if(el.dataset.split) return;
      el.dataset.split='1';
      el.innerHTML=el.textContent.trim().split(/\s+/)
        .map(w=>'<span class="w">'+w+'</span>').join(' ');
    });
    const palabras=[...mfBlock.querySelectorAll('.w')];
    const marca=mfBlock.querySelector('.mf-mark');
    const pintarMf=()=>{
      const r=mfBlock.getBoundingClientRect();
      /* El recorrido TIENE que terminar cuando el bloque ya está acomodado en
         pantalla (borde superior al 20% del alto), no después: si no, llegas a
         la sección y el texto sigue a medio teñir. Arranca en cuanto el bloque
         asoma por abajo, para estirarlo todo lo que da el trayecto. */
      const desde=innerHeight*0.88, hasta=innerHeight*0.20;
      const avance=Math.min(1,Math.max(0,(desde-r.top)/(desde-hasta)));
      const n=Math.round(avance*palabras.length);
      palabras.forEach((w,i)=>w.classList.toggle('on',i<n));
      if(marca) marca.classList.toggle('on',avance>0.92);
    };
    addEventListener('scroll',pintarMf,{passive:true});
    addEventListener('resize',pintarMf);
    pintarMf();

    /* Se eliminó el control del texto de la tela (`.ss-txt`): esperaba a que el
       manifiesto pasara para destaparlo sobre las imágenes ancladas. Sin anclaje
       no hay nada que destapar, así que el texto va visible desde el CSS. */
  }

  /* ═════════════ LA DERIVA DE LOS CARRUSELES ═════════════
     Avanza por TIEMPO, no por cuadro de pantalla. Antes sumaba una cantidad fija
     en cada `requestAnimationFrame`, así que la velocidad dependía del refresco:
     en una pantalla ProMotion, que va variando entre 24 y 120 Hz, la cinta
     cambiaba de ritmo sola — y justo después de refrescar, que es cuando más
     varía, se veía trabada.

     Dos detalles que sostienen esto:
     · La posición se lleva en `pos`, CON decimales. Leyendo `scrollLeft` en cada
       vuelta, el redondeo del navegador se comía la fracción y todo volvía a
       depender del número de cuadros.
     · `dt` va topado a 50 ms: al volver de otra pestaña el primer intervalo es
       enorme y la cinta pegaría un salto.
     Y solo trabaja mientras la sección se ve. */
  const VELOCIDAD=0.060;               // px por milisegundo → 60 px/s en cualquier pantalla
  function derivar(vp,anchoJuego,estaQuieto,seccion){
    let pos=null, ultimo=0, visible=true;
    if('IntersectionObserver' in window){
      visible=false;
      new IntersectionObserver(es=>{visible=es[0].isIntersecting;},{threshold:0}).observe(seccion);
    }
    requestAnimationFrame(function girar(t){
      const W=anchoJuego();
      if(W>0){
        if(pos===null) pos=vp.scrollLeft;
        /* si el usuario arrastró o usó la rueda, se adopta su posición */
        if(Math.abs(vp.scrollLeft-pos)>2) pos=vp.scrollLeft;
        if(ultimo&&!estaQuieto()&&visible) pos+=VELOCIDAD*Math.min(t-ultimo,50);
        if(pos>=W*2) pos-=W; else if(pos<W) pos+=W;   // el salto invisible
        vp.scrollLeft=pos;
      }
      ultimo=t;
      requestAnimationFrame(girar);
    });
  }

  /* ─────── HERO COVER · sin parallax ───────
     NO reactivar el parallax: el hero es `position:sticky`, así que se queda
     anclado mientras `scrollY` sigue creciendo. El parallax empujaba el video
     hacia abajo indefinidamente y destapaba la capa difuminada de atrás — esa
     era la franja gris que aparecía arriba al hacer scroll. */

  const CAT_META={
    /* heroClaro: la foto es clara, así que el texto va en negro y la barra en
       verde. Sin esta bandera el texto sale crema y desaparece. */
    tees:{label:'T-shirts', hero:'cat-tees.webp', heroClaro:true, tile:'tt-05.webp', destacada:'stoic-tee-beige',
      blurb:'Ribbed corduroy and 280-gram Peruvian cotton, cut oversized with a clean collar. The pieces you reach for first — the everyday surface of the work.',
      edTitle:'The everyday canvas.', edImg:'02',
      edText:'Corduroy at 330 grams, or Peruvian cotton at 280 and 200. Restrained, tactile, and made to be worn into over time.'},
    /* heroClaro: foto clara → texto en negro y barra en verde, como en tees.
       Ojo con el nombre: `cat-pants.webp` es la foto de la sección de categorías
       de SHOP; el hero es `cat-pants-hero.webp`. Son distintas. */
    pants:{label:'Pants', hero:'cat-pants-hero.webp', heroClaro:true, tile:'tp-05.webp', destacada:'stoic-pant-beige',
      blurb:'Relaxed, oversized legs cut from the same ribbed corduroy as the tees — a drawstring waist, made to build a full look.',
      edTitle:'From the same cloth.', edImg:'08',
      edText:'330 grams of poly-cotton corduroy with a touch of stretch. Designed to move — layered under Outwear or worn on their own.'},
    /* tile: era `fh-03` (la sudadera verde). El verde no existe en el catálogo
       real —los colores son negro, gris claro y gris oscuro—, así que la
       tarjeta va con la foto de la negra. */
    hoodies:{label:'Outwear', hero:'cat-hood-hero.webp', heroClaro:true, tile:'hb-03.webp',
      destacada:'zenith-black',
      blurb:'Brushed cotton at 380 grams — dense, warm and structured. In black, light grey and dark grey, each carrying the tonal print at the chest.',
      edTitle:'Warmth, weighted.', edImg:'13',
      edText:'Brushed cotton, heavy on the shoulders and soft on the inside. The print sits high on the chest — made in limited numbers.'}
  };

  /* ─────── NAV: transparente y en verde Rainforest por defecto (el sitio corre
     sobre Whisper White). Sobre las secciones marcadas .nav-invert —banda verde,
     lookbook, heroes de shop y categoría— el verde no se lee y pasa a crema. ─────── */
  const nav=D.getElementById('nav');
  if(nav){
    const inv=[...D.querySelectorAll('.nav-invert')];
    if(inv.length){
      const navIO=new IntersectionObserver(es=>{
        es.forEach(e=>{e.target._hit=e.isIntersecting;});
        pintarNav();
      },{rootMargin:'0px 0px -94% 0px',threshold:0});
      inv.forEach(el=>navIO.observe(el));
    }

    /* El HERO se trata aparte, por posición de scroll y NO con el observer:
       es `position:sticky`, así que se queda pegado arriba toda la página y el
       observer lo veía siempre intersectando → la nav se quedaba en blanco para
       siempre, ilegible sobre el fondo Whisper White. */
    const heroCover=D.querySelector('.cover');
    const sobreHero=()=>!!heroCover&&scrollY<heroCover.offsetHeight-90;

    function pintarNav(){
      /* Con la ficha de producto abierta la barra queda sobre SU fondo claro,
         no sobre la sección de detrás: si conservara el modo crema el texto
         desaparecería. Mientras esté abierta, siempre en oscuro. */
      if(D.body.classList.contains('ficha-abierta')){
        nav.classList.remove('nav--dark'); return;
      }
      /* El pilar a página completa es al revés: fondo VERDE, así que la barra
         tiene que ir en crema mientras esté abierto, pase lo que pase. */
      if(D.body.classList.contains('pilar-abierto')){
        nav.classList.add('nav--dark'); return;
      }
      nav.classList.toggle('nav--dark', sobreHero()||inv.some(el=>el._hit));
    }
    /* Se expone para poder repintarla justo al abrir y al cerrar la ficha. */
    window.__pintarNav=pintarNav;

    /* arranca holgada y se compacta en cuanto empiezas a bajar
       (referencia: serotoninn.com). Histéresis para que no parpadee
       si te quedas justo en el umbral. */
    let compacta=false;
    const medirNav=()=>{
      const y=scrollY;
      if(!compacta&&y>60){compacta=true;nav.classList.add('nav--small');}
      else if(compacta&&y<24){compacta=false;nav.classList.remove('nav--small');}
      pintarNav();
    };
    medirNav();
    addEventListener('scroll',medirNav,{passive:true});
    addEventListener('resize',pintarNav);
  }

  /* El ORIGIN BUTTON se eliminó junto con su CSS: ninguna página lo usaba.
     Era el botón cuyo relleno verde crecía desde el punto de entrada del
     cursor. Si algún día se quiere recuperar, está en el historial. */

  /* ════════ LOS PILARES A PÁGINA COMPLETA (solo about.html) ════════
     Al hacer clic en un pilar, su contenido se abre centrado en toda la
     pantalla. El texto NO se duplica aquí: se copia del propio `.v`, que es
     donde vive. Así, si se edita el HTML de la sección, el panel va solo. */
  (function pilares(){
    const panel=D.getElementById('vview'); if(!panel) return;
    const tarjetas=[...D.querySelectorAll('.values .v')]; if(!tarjetas.length) return;
    const campo=s=>panel.querySelector(s);
    let quienAbrio=null;

    tarjetas.forEach(v=>{
      v.tabIndex=0; v.setAttribute('role','button');
      v.dataset.cursor='Read';
      const t=v.querySelector('h3');
      v.setAttribute('aria-label',(t?t.textContent:'')+' — read more');
      v.addEventListener('click',()=>abrir(v));
      v.addEventListener('keydown',e=>{
        if(e.key==='Enter'||e.key===' '){e.preventDefault();abrir(v);}
      });
    });

    function abrir(v){
      const tex=s=>{const el=v.querySelector(s);return el?el.innerHTML:'';};
      campo('.vv-n').innerHTML   = tex('.vn');
      campo('.vv-t').innerHTML   = tex('h3');
      campo('.vv-lead').innerHTML= tex('.v > p');
      campo('.vv-tag').innerHTML = tex('.v-tag');
      campo('.vv-body').innerHTML= tex('.v-mas p');
      quienAbrio=v;
      panel.classList.add('open'); panel.setAttribute('aria-hidden','false');
      D.body.classList.add('pilar-abierto');
      D.body.style.overflow='hidden';
      if(window.__medirNav)  window.__medirNav();   // el alto exacto de ESTE momento
      if(window.__pintarNav) window.__pintarNav();
      if(lenis) lenis.stop();
      panel.scrollTop=0;
      panel.querySelector('.vv-close').focus({preventScroll:true});
    }
    function cerrar(){
      if(!panel.classList.contains('open')) return;
      panel.classList.remove('open'); panel.setAttribute('aria-hidden','true');
      D.body.classList.remove('pilar-abierto');
      D.body.style.overflow='';
      if(window.__pintarNav) window.__pintarNav();
      if(lenis) lenis.start();
      if(quienAbrio){quienAbrio.focus({preventScroll:true});quienAbrio=null;}
    }
    panel.querySelector('.vv-close').addEventListener('click',cerrar);
    /* clic en el vacío de los lados = volver, como en la ficha */
    panel.addEventListener('click',e=>{if(e.target===panel)cerrar();});
    addEventListener('keydown',e=>{if(e.key==='Escape')cerrar();});
  })();

  /* ═════════════ SHOP · las categorías se abren al scrollear ═════════════
     La del centro entra a pantalla completa y, conforme bajas, se encoge al
     centro mientras las de los lados crecen desde los bordes. Todo sale de
     `--p`, que va de 0 a 1; el CSS se encarga del resto (anchos, separación,
     padding). Ligado al scroll, no a un temporizador: si te detienes, se
     detiene. Copiado del sitio, no reescrito. */
  const split=D.querySelector('.cat-split');
  if(split){
    const abrir=()=>{
      /* El recorrido es el alto de la sección menos la ventana, que es justo
         lo que la etapa pegajosa se queda quieta arriba. */
      const r=split.getBoundingClientRect();
      const recorrido=Math.max(1, r.height - innerHeight);
      const p=Math.min(1, Math.max(0, -r.top / recorrido));
      /* Se suaviza el final para que aterrice en su sitio sin frenazo. */
      const e=1-Math.pow(1-p,2);
      split.style.setProperty('--p', e.toFixed(4));
    };
    addEventListener('scroll',abrir,{passive:true});
    addEventListener('resize',abrir);
    abrir();
  }

  /* ─────── Flechas del carrusel de la colección ───────
     Va DESPUÉS de pintar las piezas: antes el scroller mide 0 y las flechas
     nacerían apagadas. No hace falta esperar a las imágenes — el ancho de la
     tarjeta lo fija el CSS, así que `scrollWidth` ya es el bueno.
     Un paso = una PÁGINA EXACTA de tarjetas. No se calcula a ojo sobre el
     ancho del scroller: se mide la tarjeta real y se multiplica por `--cx-n`,
     la misma variable del CSS que decide cuántas caben. Así el carrusel nunca
     queda a medias ni asoma una tarjeta cortada, y si algún día cambia el
     número de columnas basta con tocarlo en el CSS. */
  const hpVp=D.getElementById('homePiecesVp');
  if(hpVp){
    /* solo las flechas de ESTA fila: `.hp-arrow` también es la clase de las
       flechas de la ficha destacada, y al cogerlas todas se apagaban según el
       scroll de la fila aunque quedaran fotos por ver */
    const flechas=[...D.querySelectorAll('.hp-arrow:not(.pshow-arrow)')];
    const paso=()=>{
      const tarjeta=hpVp.querySelector('.pc');
      if(!tarjeta)return hpVp.clientWidth;
      const pista=getComputedStyle(tarjeta.parentElement);
      const hueco=parseFloat(pista.columnGap)||0;
      const n=parseInt(pista.getPropertyValue('--cx-n'),10)||1;
      return (tarjeta.getBoundingClientRect().width+hueco)*n;
    };
    const pintarFlechas=()=>{
      const tope=hpVp.scrollWidth-hpVp.clientWidth-1;
      flechas.forEach(b=>{
        b.disabled = (+b.dataset.dir)<0 ? hpVp.scrollLeft<=0 : hpVp.scrollLeft>=tope;
      });
    };
    flechas.forEach(b=>b.addEventListener('click',()=>{
      hpVp.scrollBy({left:(+b.dataset.dir)*paso(),behavior:'smooth'});
    }));
    hpVp.addEventListener('scroll',pintarFlechas,{passive:true});
    addEventListener('resize',pintarFlechas);
    pintarFlechas();
  }


  /* ═════════════ «MORE ABOUT THIS PIECE» ═════════════
     Un solo interruptor para todo el sitio, por delegación: sirve igual en la
     página de prenda, en la ficha destacada y en el despliegue de compra. */
  D.addEventListener('click',ev=>{
    const b=ev.target.closest&&ev.target.closest('.mas-btn');
    if(!b) return;
    const caja=b.closest('.mas'); if(!caja) return;
    const abierto=caja.classList.toggle('abierto');
    b.setAttribute('aria-expanded',String(abierto));
    const t=b.querySelector('.mas-txt');
    if(t){
      if(!t.dataset.txt) t.dataset.txt=t.textContent;
      t.textContent=abierto?'Less':t.dataset.txt;
    }
  });

})();
